<template>
  <div class="base-table-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" @click="exportTable()">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('crm_contract_lease_order.he_tong_bian_hao')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_contract_lease_order.famcfabh')">
          <el-input v-model="formSearch.goodsName" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_contract_lease_order.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_contract_lease_order.jfsqdb')">
          <el-input v-model="formSearch.partyAName" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_contract_lease_order.qian_ding_ri_qi')">
          <custom-date-picker style="width: 100%" v-model="formSearch.dataTimes" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table tableCode="lease_order" :data="tableList" @column="setColumn" @filter="filterChange" @sort="sortChange" height="100%" :slots="['contractNo', 'goodsName']">
        <template v-slot:goodsName="scope">
          <div class="cell-link" @click="watchLeaseClass(scope.row)">
            {{ scope.row.goodsName }}
          </div>
        </template>
        <template v-slot:contractNo="scope">
          <div class="cell-link" @click="jump('/contractdetail', { contractId: scope.row.orderId, contractClass: scope.row.orderClass, parentPath: $route.path })">
            {{ scope.row.contractNo }}
          </div>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <contract-lease-detail v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></contract-lease-detail>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractLeaseDetail from '../contractLease/children/contract_lease_detail.vue';

export default {
  name: 'contractleaseorder',
  components: { contractLeaseDetail },
  data() {
    return {
      formSearch: {
        signingStartDate: '',
        signingEndDate: '',
        dataTimes: [],
        goodsName: '',
        partyAName: '',
        productCode: '',
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
  },
  methods: {
    // 获取字典项列表
    getTableList: function () {
      this.formSearch.signingStartDate = this.formSearch.dataTimes && this.formSearch.dataTimes[0] ? this.formSearch.dataTimes[0] : undefined;
      this.formSearch.signingEndDate = this.formSearch.dataTimes && this.formSearch.dataTimes[1] ? this.formSearch.dataTimes[1] : undefined;
      this.$getJSON(apis.OrderGoodsPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.OrderGoodsExport, this.formSearch).then(() => {});
    },
    // 查看租赁方案
    watchLeaseClass: function (data) {
      this.dialogModel.title = this.$t('crm_contract_lease_order.ckzlfa');
      this.dialogModel.row = data;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';
</style>
